export { default } from "./RelatedArticles";
